import React from 'react';
import { Footer } from '../Common/Footer';
import Pagination from "react-js-pagination";
import { BuyerSidebar } from '../Common/BuyerSidebar';
import { Link } from 'react-router-dom';
import Buyer from '../../Models/Buyer';
import { Header } from '../Common';
import StarRatingComponent from 'react-star-rating-component';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Products from '../../Models/Products';
import { ToastContainer, toast } from "react-toastify";
var striptags = require('striptags');

class BuyerDashboard extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 1) {
            alert('ログインしてください');
            window.location.href = '/login';
        };
        this.state = {
            _id: false,
            activePage: 1,
            itemsCountPerPage: 10,
            pageRangeDisplayed: '',
            total: [],
            buyerList: [],
            requestList: [],
            info: '',
            description: '',
            modal: false,
            rating: 0,
            product_id_for_rev: '',
            flag_for_rev: ''
        };
        this.getDashboard()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getDashboard() {
        var s = JSON.parse(window.localStorage.getItem('info'));
        var purchaseList = [];
        Buyer.getDashboard(s.id, 1).then(res => {
            res.data.message.push(
                ...res.data.requests
            )
            res.data.message.sort((a, b) => a.created_at < b.created_at ? 1 : -1)
            this.setState({ buyerList: res.data.message, requestList: res.data.requests, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
        })
        // Buyer.getDashboard(s.id, 1).then(res => {
        //     console.log(res.data)
        //     this.setState({ requestList: res.data.requests, total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
        // })
    }

    Notify(a) {
        toast(a, {
            position: "top-center"
        });
    }

    toggle_modal() {
        if (this.state.modal == true) {
            this.setState({
                modal: false
            });
        } else {
            this.setState({
                modal: true
            });
        }
    }

    toggleAll() {
        this.setState({
            modal: false
        });
    }

    updateField(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    onStarClick(nextValue, prevValue, name) {
        this.setState({ rating: nextValue });
    }

    handlePageChange(pageNumber) {
        var s = JSON.parse(window.localStorage.getItem('info'));
        Buyer.getDashboard(s.id, pageNumber).then(res => {
            if (res.data.message != null) {
                this.setState({ buyerList: res.data.message, total: res.data.total, activePage: pageNumber, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
                window.scrollTo(0, 0)
            }
        })
    }

    details(details) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (details == null || details == undefined) {
            return (
                <div className=""></div>
            )
        } else {
            return (
                <div className="">
                    {renderHTML(details.substr(0, 100))}
                </div>
            )
        }
    }

    handleSubmit(id, flag) {
        var trans_id = flag;
        document.getElementById('send_rev').disabled = true;
        const x = JSON.parse(localStorage.getItem('info'));
        if (this.state.rating == '' || this.state.rating == null) {
            this.Notify('レビュを記入してください');
            document.getElementById('send_rev').disabled = false;
        } else {
            let data = {
                purchase_id: trans_id,
                product_id: id,
                buyer_id: x.id,
                comment: this.state.description,
                rating: this.state.rating
            }
            Products.saveReview(data).then(res => {
                if (res.data.status == 200) {
                    toast('レビュを送信しまし', {
                        position: "top-center"
                    });
                    setTimeout(
                        function () {
                            this.setState({
                                modal: false,
                                description: '',
                                rating: ''
                            });
                            window.location.reload();
                        }
                            .bind(this),
                        2000
                    );
                } else {
                    this.Notify('データを取得できませんでした！ 後で試してください');
                }
            })
        }
    }

    getReview(id, flag) {
        this.setState({
            product_id_for_rev: id,
            flag_for_rev: flag
        });
        this.toggle_modal();
    }

    review(id, i, flag) {
        console.log(flag);
        if (i === 1) {
            return (
                <div className=""></div>
            )
        } else {
            return (
                <div className="">
                    <Button color="" className="ml-4"
                        onClick={this.toggle.bind(this, id)}
                        style={{ color: '#444', cursor: 'pointer', border: "1px solid #ccc", paddingTop: "1%", paddingBottom: "1%", paddingLeft: "12%", paddingRight: "12%" }}>
                        レビュー
                    </Button>
                </div>
            )
        }
    }

    purchaseProducts(flag, id, seller_id, title, short_desc, long_desc, first_name, review_status, proimg, price, requestPrice, sellerName, content,requestId) {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        console.log(title);
        //for mobile responsive
        if (isMobile) {
            if (id > 0) {
                return (
                    <div className="" style={{ border: "1px solid #f4f2f0", padding: "20px" }}>
                        <div className="row" >
                            <div className="col-md-9 remember_text" style={{ paddingBottom: '10px' }}>
                                <div className="row pb-2">
                                    <div className="col-8">
                                        <Link to={{
                                            pathname: `/my-profile-view/users/${seller_id}`,
                                            state: { id: seller_id }
                                        }} >
                                            {first_name}
                                        </Link>
                                    </div>

                                    <div className="col-4" style={{ textAlign: 'center' }}>
                                        <b>{price}</b> 円
                                    </div>
                                </div>
                                <div>
                                    <Link to={{
                                        pathname: `/categories-details/${id}`,
                                        state: { id: id }

                                    }} style={{ textDecoration: 'none' }} className="category-right">
                                        <span style={{ fontSize: "14" }}><b>{title}</b></span><br />
                                    </Link>
                                </div>
                                <div>
                                    <span className="diff_font" >{short_desc}</span>
                                </div>
                                <div className="product_description" style={{ fontSize: "12" }}>
                                    {this.details(long_desc)}
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div style={{}}>
                                    <img style={{ width: "100%", height: "120px", objectFit: 'cover' }} src={proimg} alt="" />
                                </div>
                                <br />
                                <div className="" style={{ textAlign: "center" }}>
                                    {(() => {
                                        if (review_status !== 1) {
                                            return (
                                                <button onClick={this.getReview.bind(this, id, flag)} style={{ padding: "4%", borderRadius: "4px", width: '50%' }}>レビュー</button>
                                            )
                                        } else {
                                            return (
                                                <div className="">
                                                </div>
                                            )
                                        }
                                    })()}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            } else if (id === 0 && proimg === undefined) {
                console.log('asd')
                return (
                    <div>
                        <div className="" style={{ border: "1px solid #f4f2f0", padding: "20px" }}>
                            <div className="row" >
                                <div className="col-md-9 remember_text">
                                    <div className="row  pb-2">
                                        <div className="col-8">
                                            <Link to={{
                                                pathname: `/my-profile-view/users/${seller_id}`,
                                                state: { id: seller_id }
                                            }} >
                                                {sellerName}
                                            </Link>
                                        </div>
                                        <div className="col-4" style={{ textAlign: 'center' }}>
                                            <b>{requestPrice}</b> 円
                                    </div>
                                    </div>
                                    <Link to={{
                                        pathname: `/buyer-request-details`,
                                        state: { id: requestId }
                                    }} style={{ textDecoration: 'none' }} className="category-right">
                                        <span style={{ fontSize: "14" }}><b>{title}</b></span><br />
                                    </Link>
                                    <span className="diff_font" >{short_desc}</span>
                                    <div className="product_description" style={{ fontSize: "12" }}>
                                        {this.details(content)}
                                    </div>
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>
                )
            }
        }
        //for desktop responsive
        else if (isDesktop) {
            if (id > 0) {
                return (
                    <div className="" style={{ border: "1px solid #f4f2f0", padding: "20px" }}>
                        <div className="row" >
                            <div className="col-md-9 remember_text" style={{ paddingBottom: '10px' }}>
                                <div>
                                    <Link to={{
                                        pathname: `/categories-details/${id}`,
                                        state: { id: id }

                                    }} style={{ textDecoration: 'none' }} className="category-right">
                                        <span style={{ fontSize: "14" }}><b>{title}</b></span><br />
                                    </Link>
                                </div>
                                <div>
                                    <span className="diff_font" >{short_desc}</span>
                                </div>
                                <div className="product_description" style={{ fontSize: "12" }}>
                                    {this.details(long_desc)}
                                </div>
                                <div className=" stars row" style={{ marginLeft: '0px' }}>
                                    <div style={{ width: "60%" }}>
                                        <Link to={{
                                            pathname: `/my-profile-view/users/${seller_id}`,
                                            state: { id: seller_id }
                                        }} >
                                            {first_name}
                                        </Link>
                                    </div>
                                    <div className="" style={{ textAlign: "right", width: "40%", paddingRight: "16px" }}>
                                        {(() => {
                                            if (review_status !== 1) {
                                                return (
                                                    <button onClick={this.getReview.bind(this, id, flag)} style={{ padding: "4%", borderRadius: "4px" }}>レビュー</button>
                                                )
                                            } else {
                                                return (
                                                    <div className="">
                                                    </div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div style={{}}>
                                    <img style={{ width: "100%", height: "120px", objectFit: 'cover' }} src={proimg} alt="" />
                                </div>
                                <br />
                                <div className="" style={{ textAlign: 'center' }}>
                                    <b>{price}</b> 円
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            else if (id === 0 && proimg === undefined) {
                return (
                    <div>
                        <div className="" style={{ border: "1px solid #f4f2f0", padding: "20px" }}>
                            <div className="row" >
                                <div className="col-md-9 remember_text">
                                    <Link to={{
                                        pathname: `/buyer-request-details`,
                                        state: { id: requestId }
                                    }} style={{ textDecoration: 'none' }} className="category-right">
                                        <span style={{ fontSize: "14" }}><b>{title}</b></span><br />
                                    </Link>
                                    <span className="diff_font" >{short_desc}</span>
                                    <div className="product_description" style={{ fontSize: "12" }}>
                                        {this.details(content)}
                                    </div>
                                    <div className=" stars row" style={{ marginLeft: '0px' }}>
                                        <Link to={{
                                            pathname: `/my-profile-view/users/${seller_id}`,
                                            state: { id: seller_id }
                                        }} >
                                            {sellerName}
                                        </Link>
                                        &nbsp;&nbsp;
                                </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="ml-4 pl-3">
                                        <b>{requestPrice}</b> 円
                                    </div>
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>
                )
            }
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div>
                    <Modal isOpen={this.state.modal} toggle={this.toggle_modal.bind(this)} >
                        <ModalHeader toggle={this.toggleAll.bind(this)}>レビュー   </ModalHeader>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        </button>
                        <ModalBody>
                            <h6>評価: {this.state.rating}</h6>
                            <StarRatingComponent
                                name="rate1"
                                starCount={5}
                                value={this.state.rating}
                                onStarClick={this.onStarClick.bind(this)}
                            />
                            <div>
                                <textarea type="text" className="form-control" row='10' value={this.state.description} onChange={this.updateField.bind(this, 'description')} />
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <ToastContainer />
                            <Button color="secondary" data-dismiss="modal" onClick={this.toggleAll.bind(this)}>キャンセル</Button>
                            <div onClick={this.handleSubmit.bind(this, this.state.product_id_for_rev, this.state.flag_for_rev)} >
                                <button id="send_rev" type="submit" className="btn " style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}>レビュー送信</button>
                            </div>
                        </ModalFooter>
                    </Modal>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <BuyerSidebar />
                            </div> */}
                            <div className="col-md-8">
                                <div className="mt-5  input_name big_font text-left" style={{ width: "100%", fontSize: '20px' }}>
                                    購入一覧
                                </div>
                                <div style={{ minHeight: "1150px" }}>
                                    <div className="custom_padding_dash" style={{ fontSize: '13px' }}>
                                        <div className="row">
                                            {this.state.buyerList.map(buyer =>
                                                <div className="" key={buyer.id} style={{ height: '', width: '100%' }}>
                                                    {console.log(buyer)}
                                                    {this.purchaseProducts(buyer.purchase_flag, buyer.product_id, buyer.seller_id, buyer.title, buyer.short_desc, buyer.long_desc, buyer.first_name, buyer.review_status, buyer.proimg, buyer.actual_price, buyer.price, buyer.seller, buyer.content,buyer.id)}
                                                    <br />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {(() => {
                                    if (this.state.buyerList.length < 10) {
                                        return (
                                            <div></div>
                                        )
                                    } else {
                                        return (
                                            <div className="row">
                                                <div className="col-md-4"></div>
                                                <div className="col-md-6 ml-5">
                                                    <Pagination
                                                    hideNavigation
                                                        activePage={this.state.activePage}
                                                        itemsCountPerPage={this.state.itemsCountPerPage}
                                                        totalItemsCount={this.state.total}
                                                        pageRangeDisplayed={this.state.pageRangeDisplayed}
                                                        onChange={this.handlePageChange.bind(this)}
                                                    />
                                                </div>
                                                <div className="col-md-2"></div>
                                            </div>
                                        )
                                    }
                                })()}
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for Desktop
        else if (isDesktop) {
            return (
                <div>
                    <Modal isOpen={this.state.modal} toggle={this.toggle_modal.bind(this)} >
                        <ModalHeader toggle={this.toggleAll.bind(this)}>レビュー   </ModalHeader>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        </button>
                        <ModalBody>
                            <h6>評価: {this.state.rating}</h6>
                            <StarRatingComponent
                                name="rate1"
                                starCount={5}
                                value={this.state.rating}
                                onStarClick={this.onStarClick.bind(this)}
                            />
                            <div>
                                <textarea type="text" className="form-control" row='10' value={this.state.description} onChange={this.updateField.bind(this, 'description')} />
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <ToastContainer />
                            <Button color="secondary" data-dismiss="modal" onClick={this.toggleAll.bind(this)}>キャンセル</Button>
                            <div onClick={this.handleSubmit.bind(this, this.state.product_id_for_rev, this.state.flag_for_rev)} >
                                <button id="send_rev" type="submit" className="btn " style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}>レビュー送信</button>
                            </div>
                        </ModalFooter>
                    </Modal>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <BuyerSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className=" mb-1 input_name big_font text-left" style={{ width: "100%" }}>
                                            購入一覧
                                    </div>
                                        <div style={{ minHeight: "1150px" }}>
                                            <div className="custom_padding_dash pt-0" >
                                                <div className="row">
                                                    {/* {this.purchaseList()} */}
                                                    {this.state.buyerList.map(buyer =>
                                                        <div className="" key={buyer.id} style={{ height: '', width: '100%' }}>
                                                            {this.purchaseProducts(buyer.purchase_flag, buyer.product_id, buyer.seller_id, buyer.title, buyer.short_desc, buyer.long_desc, buyer.first_name, buyer.review_status, buyer.proimg, buyer.actual_price, buyer.price, buyer.seller, buyer.content,buyer.id)}
                                                            <br />
                                                        </div>
                                                    )}
                                                    {/* {this.state.requestList.map(buyer =>
                                                        <div className="" key={buyer.id} style={{ height: '', width: '100%' }}>
                                                            {this.purchaseProducts(buyer.purchase_flag, buyer.product_id, buyer.seller_id, buyer.img, buyer.title, buyer.short_desc, buyer.content, buyer.seller, buyer.stars, buyer.review_status, buyer.proimg, buyer.price)}
                                                            <br />
                                                        </div>
                                                    )} */}
                                                </div>
                                            </div>
                                            <div>
                                            </div>
                                        </div>

                                        {(() => {
                                            if (this.state.buyerList.length < 10) {
                                                return (
                                                    <div></div>
                                                )
                                            } else {
                                                return (
                                                    <div className="row">
                                                        <div className="col-md-4"></div>
                                                        <div className="col-md-6 ml-5">
                                                            <Pagination
                                                                hideNavigation
                                                                activePage={this.state.activePage}
                                                                itemsCountPerPage={this.state.itemsCountPerPage}
                                                                totalItemsCount={this.state.total}
                                                                pageRangeDisplayed={this.state.pageRangeDisplayed}
                                                                onChange={this.handlePageChange.bind(this)}
                                                            />
                                                        </div>
                                                        <div className="col-md-2"></div>
                                                    </div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { BuyerDashboard }